import BaseModel from "../base/baseModel";

export default class ConfiguracaoEtapaPCPModel extends BaseModel {
    id?: number = null;
    franquiaId?: number = null;
    etapaGradePendenteId?: number = null;
    etapaBloqueioManipulacaoId?: number = null;
    etapaEntregaEmProducaoId?: number = null;
    etapaEntregaEmExecucaoId?: number = null;
    etapaEntregaEmSaiuParaEntregaId?: number = null;
    etapaEntregaEntregueId?: number = null;
    etapaEmissaoNotaFiscalId?: number = null;
}
